import { type RouteRecordRaw } from "vue-router";

export const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "mailbox",
    name: "mailbox",
    component: () => import("./pages/MailboxPage.vue"),
    meta: {
      requiresAuth: true,
      requiresStaff: true,
      title: "menu.mailbox",
    },
  },
];
